module.exports = __webpack_public_path__ + "img/updatePwd.18258a7a.png";